import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import '@navegasistemas/dls-navega-rjs/style.css'
import './index.css'
import { queryClient } from '@/lib/query-client'
import { Root } from './root.tsx'

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://ad932c98203cd343a9b1c4e89cb335d8@o4508167855472640.ingest.us.sentry.io/4511479435624448',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Root />
    </QueryClientProvider>
  </StrictMode>,
)
